import styled from "styled-components"

export const Row = styled.div`
    display: flex;
    gap: 20px;
    width: 100%;
`;

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

export const Title = styled.span`
    color: ${({ theme }) => theme.colors.text};
    font-size: 16px;
`;